import { gql } from "apollo-boost";



export const CREATE_BRAND = gql`
mutation CreateBrand($data: BrandInput) {
    createBrand(data: $data) {
      id
    }
  }
`


export const DELETE_BRAND = gql`
mutation DeleteBrand($where: BrandWhereInputOne!) {
    deleteBrand(where: $where) {
      id
    }
  }
`

export const UPDATE_BRAND = gql`
mutation UpdateBrand($where: BrandWhereInputOne!, $data: BrandInput) {
    updateBrand(where: $where, data: $data) {
      id
    }
  }

`